// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3eBlQ","footer":"ReportModalFilter_footer__146O0"};